import { HTMLRenderer, HTMLRendererProps } from "@picovico/ui";
import React from "react";

function RenderHtml(props: HTMLRendererProps) {
  return <HTMLRenderer {...props} />;
}

export default RenderHtml;
